module.exports = __webpack_public_path__ + "img/1.004d2cd3.png";